import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  selectPersistentError,
  selectQuestionnaire,
} from './state/form.selectors';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { setAutoSave } from './state/form.actions';
import { HeaderComponent } from './shared/header/header.component';
import { AsyncPipe } from '@angular/common';
import { PersistentErrorComponent } from './error/persistent-error/persistent-error.component';
import { ToastComponent } from './error/toast/toast.component';
import { TitleComponent } from './shared/title/title.component';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [
    HeaderComponent,
    PersistentErrorComponent,
    ToastComponent,
    TitleComponent,
    RouterOutlet,
    AsyncPipe,
  ],
})
export class AppComponent {
  private readonly store = inject(Store);

  title = 'prior-auth-dtr';

  persistentError$ = this.store.select(selectPersistentError);
  questionnaire$ = this.store.select(selectQuestionnaire);
  constructor() {
    const translate = inject(TranslateService);
    const store = this.store;

    translate.setDefaultLang('en');
    translate.use('en');
    store.dispatch(setAutoSave({ autoSave: environment.autoSave }));
  }
}
